function getDynamicDataset(aggProps, zone) {
	var _aggZoneProps$techSpa;
	const aggZoneProps = aggProps.zones[zone.uuid];
	if (!aggZoneProps) return aggProps.dataset;
	if (!((_aggZoneProps$techSpa = aggZoneProps.techSpaces.userDefinedAttributes) === null || _aggZoneProps$techSpa === void 0 ? void 0 : _aggZoneProps$techSpa.Sprinklered)) return aggProps.dataset;
	return {
		...aggProps.dataset,
		aggConfig: {
			...aggProps.dataset.aggConfig,
			sprinkleredFflThreshold: 0
		}
	};
}
export { getDynamicDataset };

//# sourceMappingURL=index32.js.map